module.exports = __webpack_public_path__ + "static/media/catalouge-05.cb46dffc.jpg";